export const Api = {
  contacts: 'page/all-by-slug/contacts',
};
